export const times = [
  {
    id: '126644',
    time: '8:00',
    free: true,
    placeholder: 'Время свободно'
  },
  {
    id: '87598759',
    time: '9:00',
    free: false,
    placeholder: 'Время уже занято'
  },
  {
    id: '238942398',
    time: '10:00',
    free: true,
    placeholder: 'Время свободно'
  },
  {
    id: '727468',
    time: '11:00',
    free: true,
    placeholder: 'Время свободно'
  },
  {
    id: '87423984',
    time: '12:00',
    free: false,
    placeholder: 'Время уже занято'
  },
  {
    id: '4982374',
    time: '13:00',
    free: false,
    placeholder: 'Время уже занято'
  },
  {
    id: '8547927',
    time: '14:00',
    free: true,
    placeholder: 'Время свободно'
  },
  {
    id: '958737',
    time: '15:00',
    free: false,
    placeholder: 'Время уже занято'
  },
  {
    id: '8795272',
    time: '16:00',
    free: false,
    placeholder: 'Время уже занято'
  },
];